import type { AuthColor, ViewId } from "@/shared/types/common";
import type { AuthService } from "./auth-service";
import { UserRoles, WIDGETS_BY_ROLE } from "./user-roles";

export class AuthServiceGold implements AuthService {
	get customTabsLimit(): number {
		return 100;
	}

	get savedStateLimit(): number {
		return 100;
	}

	get isNavigationButtonAllowed(): boolean {
		return true;
	}

	get color(): AuthColor {
		return "gold";
	}

	get isPremium(): boolean {
		return true;
	}

	get allowedWidgets(): ViewId[] {
		return WIDGETS_BY_ROLE.gold;
	}

	get role() {
		return UserRoles.GOLD;
	}

	get isAdvancedQuoteAllowed(): boolean {
		return true;
	}
}
